import React, { useEffect, useState } from 'react';
import { Button, Card, Form, InputNumber, Result, Space, message } from 'antd';
import AdaptiveTable from '../components/AdaptiveTable';
import { useAuth } from '../context/AuthContext';
import { canViewOperationLogs } from '../utils/permissions';
import { shipmentSlaThresholdApi } from '../api/kfc';

const STATUS_ROWS: { status: string; label: string }[] = [
  { status: 'PRE_DECLARATION', label: '预申报' },
  { status: 'SUBMITTED_TO_DEPOT', label: '已交代理仓' },
  { status: 'HANDOVER_CONFIRMING', label: '交货确认中' },
  { status: 'CONFIRMED_WAIT_DEPARTURE', label: '准备运输' },
  { status: 'IN_TRANSIT', label: '运输中' },
  { status: 'OUT_FOR_DELIVERY', label: '待派送' },
];

const ShipmentSlaThresholdPage: React.FC = () => {
  const { session } = useAuth();
  const allowed = canViewOperationLogs(session.identity?.traits);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (!allowed) return;
    setLoading(true);
    shipmentSlaThresholdApi
      .get()
      .then((res) => {
        const m = res.data?.thresholdsByStatus || {};
        const values: Record<string, number> = {};
        STATUS_ROWS.forEach((r) => {
          values[r.status] = m[r.status] ?? 1;
        });
        form.setFieldsValue(values);
      })
      .catch((e: { response?: { data?: { message?: string }; status?: number } }) => {
        if (e.response?.status === 403) message.error('无权查看');
        else message.error(e.response?.data?.message || '加载失败');
      })
      .finally(() => setLoading(false));
  }, [allowed, form]);

  if (!allowed) {
    return <Result status="403" title="无权访问" subTitle="仅管理员可配置运单时效阈值" />;
  }

  const onSave = () => {
    form.validateFields().then((values) => {
      setSaving(true);
      shipmentSlaThresholdApi
        .put({ thresholdsByStatus: values })
        .then(() => message.success('已保存'))
        .catch((e: { response?: { data?: { message?: string } } }) =>
          message.error(e.response?.data?.message || '保存失败')
        )
        .finally(() => setSaving(false));
    });
  };

  return (
    <Card
      title="运单时效阈值"
      loading={loading}
      extra={
        <Button type="primary" loading={saving} onClick={onSave}>
          保存
        </Button>
      }
    >
      <Form form={form} layout="vertical">
        <AdaptiveTable
          pagination={false}
          rowKey="status"
          dataSource={STATUS_ROWS}
          columns={[
            { title: '状态', dataIndex: 'label', width: 160 },
            { title: '状态码', dataIndex: 'status', width: 220 },
            {
              title: '停留阈值（天）',
              width: 200,
              render: (_, r) => (
                <Form.Item
                  name={r.status}
                  rules={[{ required: true, message: '必填' }]}
                  style={{ margin: 0 }}
                >
                  <InputNumber min={1} precision={0} style={{ width: 120 }} />
                </Form.Item>
              ),
            },
          ]}
        />
      </Form>
      <Space style={{ marginTop: 12 }}>
        <span style={{ color: '#888' }}>超过阈值的运单在运单看板中计为告警；未在此列表的状态不告警。</span>
      </Space>
    </Card>
  );
};

export default ShipmentSlaThresholdPage;
